import moment from 'moment';

export function formatDateTimeToDate(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MM/DD/YYYY h:mm A');
}

export function formatDateTimeSecToDate(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MM/DD/YYYY LTS');
}

export function formatToLongDate(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('dddd, MMMM Do YYYY');
}

export function formatToLongDateWithNoDaySuffix(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('dddd, MMMM D, YYYY');
}

export function formatToMediumShortDate(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MMMM DD YYYY');
}

export function formatToMediumShortDateWithComma(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MMMM DD, YYYY');
}


export function formatToShortDateWithComma(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MMM DD, YYYY');
}

export function formatToShortDate(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MM/DD/YYYY');
}

export function formatToLongDateWithYear(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('dddd, MMMM D, YYYY');
}

export function formatToLongDateLocalTimeWithNoYear(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).local().format('dddd, MMMM D');
}

export function formatTime(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('h:mm A');
}

export function formatTimeAddEST(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('h:mm A') + " EST";
}

export function formatTimeWithOutAmPm(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('h:mm');
}

export function formatTimeWithJustAmPm(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('A');
}

export function formatToMonthAbbr(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('MMM');
}

export function formatToDayNumber(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('D');
}

export function formatToDayOfWeekAbbr(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('ddd');
}

export function formatToYearNumber(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment.utc(rawValue).format('YYYY');
}

//format date as recieved 
export function formatDateTimeSecToDateAsIs(rawValue) {
    return rawValue == null || rawValue == '' ? null : moment(rawValue).format('MM/DD/YYYY LTS');
}

export function formatNumberWithCommas(rawValue) {
    if (rawValue == null) {
        return rawValue;
    }

    if (rawValue == 0) {
        return '0';
    }

    if (rawValue == '') {
        return rawValue;
    }

    return rawValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumberTo2Decimals(rawValue) {
    return rawValue == null ? null : parseFloat(Math.round(rawValue * 100) / 100).toFixed(2);
}

export function formatNumberToUsMoney(rawValue) {

    if (rawValue == null) {
        return null;
    }

    if (rawValue == 0) {
        return '$0.00';
    }

    return '$' + formatNumberWithCommas(parseFloat(Math.round(rawValue * 100) / 100).toFixed(2));
}

export function formatUsPhoneNumberWithAreaCode(rawValue) {

    if (rawValue) {
        let sanitizeValue = rawValue.replace('-', '');

        if (sanitizeValue.length == 10) {
            return `(${sanitizeValue.substring(0, 3)}) ${sanitizeValue.substring(3, 6)}-${sanitizeValue.substring(6, 10)}`;
        }
    }

    return rawValue;
}

export function ToYesNo(booleanValue) {
    if (booleanValue == null) {
        return booleanValue;
    }

    return booleanValue ? 'Yes' : 'No';
}

export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return 'n/a'
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    if (i === 0) return `${bytes} ${sizes[i]})`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
}

export const usaPhoneNumberFormat = '(###) ###-####';
export const usaDateFormat = '##/##/####';
